<template>
  <div class="bb-chart">
    <div class="bb-chart-header">
      <h2 class="bb-chart-header__title">NET PROFIT</h2>
      <div class="bb-chart-header-total">
        <span class="bb-chart-header-total__today">
          Today -
        </span>
        {{convertNumber(total)}} AED
      </div>
    </div>
    <chart :options="chartOptions"/>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import convertNumber from '@/mixin/convertNumber'
import _ from 'lodash'

export default {
  name: 'ChartNetProfit',
  components: {
    Chart
  },
  props: ['total', 'data'],
  mixins: [convertNumber],
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'areaspline',
          height: 153
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          maxPadding: 0,
          type: 'category',
          labels: {
            style: {
              color: '#AFAFAF',
              fontSize: '11px',
              fontFamily: 'SF UI Display, sans-serif'
            }
          }
        },
        yAxis: {
          maxPadding: 0,
          gridLineColor: '#EEEEEE',
          title: {
            text: ''
          },
          labels: {
            format: '{value}',
            style: {
              color: '#AFAFAF',
              fontSize: '11px',
              fontFamily: 'SF UI Display, sans-serif'
            }
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          outside: true,
          distance: 10,
          headerFormat: '',
          useHTML: true,
          formatter: function () {
            const pointY = String(this.point.y.toFixed(2)).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            return `<div class="bb-chart-tooltip"><b class="bb-chart-tooltip__num">${pointY}</b>  AED</div>`
          },
          shadow: false,
          borderColor: 'rgba(0,0,0,0)',
          backgroundColor: 'rgba(0,0,0,0)'
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
            marker: {
              fillColor: '#FFFFFF',
              lineWidth: 3,
              lineColor: null,
              states: {
                hover: {
                  lineWidthPlus: 0,
                  radiusPlus: 0
                }
              }
            },
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          series: {
            pointPlacement: 'on'
          }
        },
        series: [{
          cursor: 'pointer',
          color: '#0D7BC4',
          borderRadius: 4,
          data: this.data,
          dataLabels: {
            enabled: false
          }
        }]
      }
    }
  },
  watch: {
    data () {
      const originSeries = _.cloneDeep(this.chartOptions.series)
      originSeries[0].data = this.data
      this.$set(this.chartOptions, 'series', originSeries)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Finance/Dashboard/NetProfit/ChartNetProfit.vue